import React from "react";
import { FlexDiv } from "../assets/styles/style";
import AllSpeakingComponents from "../components/Speaking/AllSpeakingComponents";


const Writing = () => {
  return (
    <>
      <FlexDiv>
        <AllSpeakingComponents />
      </FlexDiv>
    </>
  );
};

export default Writing;

//Currently This page is being used to render all the cards and components during development 
